import script from "./DropdownMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./DropdownMenuItem.vue?vue&type=style&index=0&id=68431ebf&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68431ebf"]])

export default __exports__